import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';
import { createFormStoreEvents } from '../../create-form-store-events';

export const offshoreBunkerFormEvents = createFormStoreEvents('offshoreBunkerFormStore');

export const offshoreBunkerEvents = eventGroup({
  source: 'offshoreBunkerFormStore',
  events: {
    updateBunkerRow: type<{
      rowIndex: number;
      density?: number;
      lcv?: number;
      sulphur?: number;
      viscosity?: number;
    }>(),
    removeBunkerRow: type<{ rowIndex: number }>(),
    addBunkerRow: type<void>(),
    clearBunkerRow: type<{ rowIndex: number; omitFields?: string[] }>(),
  },
});
